import PropTypes from "prop-types";

const { arrayOf, bool, shape, string } = PropTypes;

const eveScoresType = arrayOf(
  arrayOf(
    shape({
      aa_change: string,
      class_75: string,
      current_variant: bool,
      eve_score: string,
    }).isRequired
  )
);

export { eveScoresType };
